/**
 * @todo: Remove usage of this file, user `@irati/types` directly instead
 */
import { PaymentProvider, PaymentStatus, PaymentOrderStatus, PaymentCurrencyType } from "@irati/types";
export { PaymentProvider, PaymentStatus, PaymentOrderStatus, PaymentCurrencyType };
/** @note: This does not directly map to auto-gen yet */
export var WalletType;
(function (WalletType) {
    WalletType["User"] = "personal";
    WalletType["Rewards"] = "rewards";
})(WalletType || (WalletType = {}));
